module.exports = require("./../../_gen/starling/utils/MatrixUtil");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/MatrixUtil.js
// module id = 246
// module chunks = 0